import { useField } from 'formik';

import Emoticon from '../layout/Emoticon';
import EmoticonContainer from '../layout/EmoticonContainer';

export default function SentimentInput(props: { name: string }) {
	const choices = ['😥', '😕', '🤔', '🙂', '😃'];
	const [, { value }, { setValue }] = useField(props.name);

	return (
		<EmoticonContainer>
			{choices.map((emoji, index) => (
				<Emoticon key={index} selected={value === index} onClick={() => setValue(index)}>
					{emoji}
				</Emoticon>
			))}
		</EmoticonContainer>
	);
}
